import React from "react"
import logoContrato from "../../../../images/planes/Skol_Sello_calidad.svg"

import "./contrato.scss"

export const ContratoSection = ({ classTitle }) => {
  return (
    <div className={`${classTitle}-contrato-section-container`}>
      <div
        className={`${classTitle}-contrato-img-container`}
        data-sal="slide-up"
        data-sal-delay="200"
        data-sal-easing="ease"
      >
        <img
          src={logoContrato}
          className={`contrato-img`}
          alt={`contrato-img`}
        />
      </div>
      <div
        className={`${classTitle}-contrato-text-container`}
        data-sal="slide-up"
        data-sal-delay="200"
        data-sal-easing="ease"
      >
        <p>
          Nuestros contratos de mantenimiento están pensados para garantizar,
          más allá de las garantías obligatorias de los equipos por parte del
          fabricante y de <span>Skol Solutions</span> en sus instalaciones, el
          óptimo funcionamiento de los equipos y sistemas a lo largo de su vida
          útil, adaptándose a las necesidades de cada cliente.
        </p>
        <p>
          Éstos pueden incluir un número específico de visitas de mantenimiento
          preventivo, disponibilidad para actuaciones in situ a petición del
          cliente o una combinación de ambos.
        </p>
        <p>
          También tenemos a disposición de nuestros clientes una modalidad de
          mantenimiento preferente con las máximas prestaciones de soporte y
          acuerdos de nivel de servicios.
        </p>
      </div>
    </div>
  )
}
